interface BreadcrumbPage {
  name: string;
  href: string;
  current: boolean;
}

interface BreadcrumbsProps {
  pages: BreadcrumbPage[];
}

export function Breadcrumbs({ pages }: BreadcrumbsProps) {
  return (
    <nav aria-label='Breadcrumb' className='flex'>
      <ol className='flex items-center space-x-1'>
        {pages.map((page, index) => (
          <li key={page.name}>
            <div className='flex items-center'>
              {/* Render separator only if it's not the first item */}
              {index > 0 && (
                <svg
                  fill='currentColor'
                  viewBox='0 0 20 20'
                  aria-hidden='true'
                  className='size-5 shrink-0 text-gray-950'
                >
                  <path d='M5.555 17.776l8-16 .894.448-8 16-.894-.448z' />
                </svg>
              )}
              <a
                href={page.href}
                aria-current={page.current ? 'page' : undefined}
                className={`text-sm font-normal leading-5 font-inter ${
                  page.current
                    ? 'text-gray-950'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                {page.name}
              </a>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
